import { IconButton } from "@chakra-ui/react";
import { ArrowLeft } from "phosphor-react";
import React from "react";
import { COLORS } from "../../../../Helper/Colors";

export const BackButton = ({ onClick, ...rest }) => {
	return (
		<IconButton
			aria-label='go back'
			icon={<ArrowLeft weight='bold' size={rest.size || 24} />}
			color={rest.color || COLORS.brandDark}
			bgColor={rest.bgColor || COLORS.brandLight}
			onClick={onClick}
			marginRight={2}
			{...rest}
		/>
	);
};
